import { styled } from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 0 0 6px;
  min-height: 27px;
  border-radius: 18px;
  background: ${({ theme }) => theme.colors.grayAccent};
  font-size: 13px;
  font-weight: 600;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.secondaryDark};
`

export const Icon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 15px;
    height: 15px;
  }
`

export const TextWrapper = styled.span`
  flex: 1;
`

export const Cta = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
`

export const Dismiss = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondaryDark};
  padding: 2px 6px 2px 6px;

  svg {
    width: 20px;
    height: 20px;
  }
`
